import { useSwalDialog } from '@/use/swalDialog';
import util from '@/Utils/util';

export const catchErrorMessageBox = async <T>(fn: () => T): Promise<T | undefined> => {
  const { showErrorPopupDialog } = useSwalDialog();

  try {
    return await fn();
  } catch (error: any) {
    console.error(error);

    const errorMessage = util.getGraphqlError(error, false);

    showErrorPopupDialog({
      text: errorMessage,
    });

    throw error;
  }
};
